export default {
      id: "siglevel-site-audits-usage",
      viewBox: "0 0 32 31",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#siglevel-site-audits",
      toString: function () {
        return this.url;
      }
    }